module.exports = __webpack_public_path__ + "img/8.2430b680.png";